/* ============================================================
   ASTROMEDA NEW TOP PAGE — Hero Slider Auto-Rotate + UX
   - 6 IP の自動切替 (3000ms)
   - マウスホバー一時停止
   - タッチスワイプ (横方向 30px 以上で前後)
   - キーボード ← / → ナビ
   ============================================================ */
(function(){
  'use strict';
  function init() {
    var slides = document.querySelectorAll('.hero-slide');
    var dots   = document.querySelectorAll('.hero-dot');
    if (!slides.length) return;

    var idx   = 0;
    var timer = null;

    function show(i){
      idx = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.classList.toggle('active', k === idx); });
      dots.forEach(function(d, k){ d.classList.toggle('active', k === idx); });
    }
    function start(){ stop(); timer = setInterval(function(){ show(idx + 1); }, 3000); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }

    /* dots: クリックで該当スライド表示 + 自動再生再開 */
    dots.forEach(function(d, i){
      d.addEventListener('click', function(e){ e.preventDefault(); show(i); start(); });
    });

    var cont = document.querySelector('.hero-container');
    if (cont) {
      cont.addEventListener('mouseenter', stop);
      cont.addEventListener('mouseleave', start);

      /* タッチスワイプ */
      var touchStartX = null;
      cont.addEventListener('touchstart', function(e){
        touchStartX = e.touches[0].clientX;
        stop();
      }, {passive: true});
      cont.addEventListener('touchend', function(e){
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 30) {
          show(idx + (dx < 0 ? 1 : -1));
        }
        touchStartX = null;
        start();
      }, {passive: true});
    }

    /* キーボード ← / → ナビ (アクセシビリティ) */
    document.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft')  { show(idx - 1); start(); }
      if (e.key === 'ArrowRight') { show(idx + 1); start(); }
    });

    /* 初期表示 + 自動再生開始 */
    show(0);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
